import { render, staticRenderFns } from "./MediabankCategoriesFilter.vue?vue&type=template&id=0767e63b&"
import script from "./MediabankCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./MediabankCategoriesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports